import { colors } from '@atlaskit/theme';
import React from 'react';
import styled from 'styled-components';

import { cardContainerFrameStyle, iconContainerStyle } from '../style';

const Container = styled.div`
  ${cardContainerFrameStyle};
  cursor: default;
`;

const IconContainerSkeleton = styled.div`
  ${iconContainerStyle}
  background-color: ${colors.N20};
`;

const SiteTextContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const ProductTextContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 4px;
`;

export const TextSkeleton = styled.div<{ width: string }>`
  background-color: ${colors.N20};
  display: inline-block;
  border-radius: 3px;
  margin: 1.5px;
  font-size: 9px;
  line-height: 13px;
  min-height: 13px;
  width: ${({ width }) => width};
`;

const CardSkeleton: React.FunctionComponent = () => {
  return (
    <Container>
      <IconContainerSkeleton />
      <ProductTextContainer>
        <TextSkeleton width="50%">&nbsp;</TextSkeleton>
      </ProductTextContainer>
      <SiteTextContainer>
        <TextSkeleton width="80%">&nbsp;</TextSkeleton>
      </SiteTextContainer>
    </Container>
  );
};

export default CardSkeleton;
